var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"primary-menu"},[_c('ListLinks',{attrs:{"listCssClass":"menu-container","sublistCssClass":"sub-menu-container","itemCssClass":"menu-item","activeCssClass":"current","linkCssClass":"menu-link","routes":_vm.routes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }